import { render, staticRenderFns } from "./DashboardOrders.vue?vue&type=template&id=1b672e44"
import script from "./DashboardOrders.vue?vue&type=script&lang=js"
export * from "./DashboardOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports